// Lightweight identity for attribution (no auth) — a first name kept locally.
const KEY = "messe.editor";

export function getEditor(): string {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setEditor(name: string): void {
  try {
    localStorage.setItem(KEY, name);
  } catch {
    /* ignore */
  }
}
